























































































import VueOptions from '@utils/VueOptions'
import TitlePatternUtility from '@utils/TitlePatternUtility'
import LoadingIndicator from '@components/LoadingIndicator'
import TagBar from '@ui/TagBar'
import SponsorSetList from '@ui/SponsorSet/SponsorSetList'
import CalendarService from '@services/CalendarService'

settings =
  name: 'AudienceAvailabilityCard'

  resources:
    audience_availability:
      resourceName: 'audience_availability'
      slug: 'audience_availabilities/:item.id'
      fetch: false

  vue:
    props: ['item', 'options', 'actions']

    components: {
      LoadingIndicator,
      TagBar,
      SponsorSetList,
    }

    computed:
      isSameDay: ->
        return false
        # @audienceListing.local_start_day is @audienceListing.local_end_day

      editable: ->
        return @options.editable if @options?.editable?
        true

      title: ->
        TitlePatternUtility.formatAvailabilityTitle @item

      tags: -> @compact [...new Set([@item.primary_type, ...@item.types])]

      tagsFilter: -> []
      tagOptionsForTags: ->
        {
          bar: {
            theme: 'card',
            max: 4
          },
          tag: {
            theme: 'card',
            format: 'formatListingType',
            maxLength: 12
          }
        }

      statsCount: ->
        samplingSpaces = @item.spaces.filter((s) => s.type is 'product_sampling')
        onsiteSpaces = @item.spaces.filter((s) => s.type is 'onsite_space')

        {
          sampling: samplingSpaces.length,
          onsite: onsiteSpaces.length,
        }

      availabilityDate: ->
        { dates, seasons } = @item
        { starts_on: date, repeats, rrule_string: rruleString } = dates[0]
        CalendarService.formatCalendarDate { date, repeats, rruleString, seasons }

      location: ->
        @$options.filters.formatLocation @item

    methods:
      hiNavToDetails: ->
        @$router.push { name: 'AudienceAvailabilityShowPage', params: { audienceAvailabilityId: @item.id } }
      hiNavToPreview: ->
        @$router.push { name: 'AudienceAvailabilityPreviewPage', params: { audienceAvailabilityId: @item.id } }

      hiTogglePublished: (published) ->
        payload = { audience_availability_id: @item.id }
        action = if published then 'publish' else 'unpublish'
        @triggerResource 'audience_availability', action, payload
      onAudienceAvailabilityPublish: ->
        # @fetch 'audience_availability'
      onAudienceAvailabilityUnpublish: ->
        # @fetch 'audience_availability'

export default VueOptions.vue settings
